{
    "mreServiceBase": "https://test.kc-np.o360.cloud/Handlers/saml2.ashx",
    "mreBaseUrl": "https://www.medicalreferenceengine.com/mre/",
    "tokenServer": "/Token/token/",
    "url": "/",
    "appName": "kcApp",
    "secret": ""
}
